import { post, put, remove, URL, db } from 'utils';
import { logout } from './auth';
import { fetch } from './fetch';

export const SET_USER = 'USER.SET_USER';
export const UPDATE_USER = 'USER.UPDATE_USER';
export const CHANGE_NAME = 'USER.CHANGE_NAME';
export const ADD_ACCOUNT = 'USER.ADD_ACCOUNT';
export const REMOVE_ACCOUNT = 'USER.REMOVE_ACCOUNT';
export const VERIFY_ADD_ACCOUNT = 'USER.VERIFY_ADD_ACCOUNT';
export const UPLOAD_AVATAR = 'USER.UPLOAD_AVATAR';

export const getUser = auth => (dispatch, getState) => {
  db.watch(`users/${auth.id}`, value => {
    if (value) {
      dispatch(setUser({ ...value, current_session: auth.session_id }));
    } else {
      dispatch(logout());
    }
  });
};
export const setUser = user => ({ type: SET_USER, payload: user });

export const update = params => (dispatch, getState) => {
  const request = { url: URL.USER.USER, method: put, params };
  fetch(request, UPDATE_USER);
};

export const changeName = ({ name }) => (dispatch, getState) => {
  const request = { url: URL.USER.CHANGE_NAME, method: put, params: { name } };
  fetch(request, CHANGE_NAME);
};

export const addAccount = params => (dispatch, getState) => {
  const request = { url: URL.USER.ACCOUNT, method: post, params };
  fetch(request, ADD_ACCOUNT);
};

export const removeAccount = params => (dispatch, getState) => {
  const request = { url: URL.USER.ACCOUNT, method: remove, params };
  fetch(request, REMOVE_ACCOUNT);
};

export const verifyAddAccount = params => (dispatch, getState) => {
  const request = { url: URL.USER.VERIFY_ADD_ACCOUNT, method: post, params };
  fetch(request, VERIFY_ADD_ACCOUNT);
};

export const uploadAvatar = ({ upload }) => (dispatch, getState) => {
  const request = { url: URL.USER.UPLOAD_AVATAR, method: put, params: { upload } };
  fetch(request, UPLOAD_AVATAR);
};



// WEBPACK FOOTER //
// ./src/actions/user.js